import { axiosRequest } from '@/util/axios-request';
var method = 'get';
var getTable = '/web/Job_title/list';
var getAllLis = '/web/Job_title/allList';
var create = '/web/Job_title/create';
var edit = '/web/Job_title/edit';
var del = '/web/Job_title/del';
var getType = '/web/Job_title/jobTitleType';
var getCsrfToken = '/web/job_title_grade_and_rank/getInit';
var getJobLeave = '/web/job_title_grade_and_rank/getGradeList';
var delJobLeave = '/web/job_title_grade_and_rank/delGrade';
var saveLeave = '/web/job_title_grade_and_rank/saveRank';
var getLeave = '/web/job_title_grade_and_rank/getRankList';
var delRank = '/web/job_title_grade_and_rank/delRank';
var saveGrade = '/web/job_title_grade_and_rank/saveGrade';
export var getTableFn = function getTableFn(params) {
  return axiosRequest({
    url: getTable,
    method: method,
    params: params
  });
};

// 获取职位列表
export var getAllListFn = function getAllListFn() {
  return axiosRequest({
    url: getAllLis,
    method: method
  });
};
export var createFn = function createFn(data) {
  return axiosRequest({
    url: create,
    data: data
  });
};
export var editFn = function editFn(data) {
  return axiosRequest({
    url: edit,
    data: data
  });
};
export var delFn = function delFn(data) {
  return axiosRequest({
    url: del,
    data: data
  });
};
export var getTypeFn = function getTypeFn(params) {
  return axiosRequest({
    url: getType,
    method: method,
    params: params
  });
};
export var getCsrfTokenFn = function getCsrfTokenFn() {
  return axiosRequest({
    url: getCsrfToken
  });
};

// 获取职等
export var getJobLeaveFn = function getJobLeaveFn() {
  return axiosRequest({
    url: getJobLeave
  });
};

// 删除职等
export var delJobLeaveFn = function delJobLeaveFn(data) {
  return axiosRequest({
    url: delJobLeave,
    data: data
  });
};

// 保存职级
export var saveLeaveFn = function saveLeaveFn(data) {
  return axiosRequest({
    url: saveLeave,
    data: data
  });
};

// 获取职级

export var getLeaveFn = function getLeaveFn(data) {
  return axiosRequest({
    url: getLeave,
    data: data
  });
};

// 删除职级
export var delRankFn = function delRankFn(data) {
  return axiosRequest({
    url: delRank,
    data: data
  });
};

// 保存职等

export var saveGradeFn = function saveGradeFn(params) {
  return axiosRequest({
    url: saveGrade,
    params: params
  });
};